import {axiosNodeClient} from '../http';

export const checkinServiceNode = {
    create,
    bookStaffsAndServices,
    update,
    del,
    checkout,
    get,
    getInfoApplyPoint,
    applyUsePoint,
    search,
    total,
    today
}

function create(data) {
    return axiosNodeClient.post('/checkin', data);
}

/**
 * Book staffs and services when check-in
 * */
function bookStaffsAndServices(data) {
    return axiosNodeClient.put(`/checkin/${data.id}/book`, data);
}

function get(id) {
    if (id && id > 0) {
        return axiosNodeClient.get(`/checkin/${id}`);
    } else {
        return axiosNodeClient.get(`/checkin`);
    }
}

function getInfoApplyPoint(checkinId) {
    return axiosNodeClient.get(`/checkin/${checkinId}/info-apply-point`);
}

function applyUsePoint(data) {
    return axiosNodeClient.put(`/checkin/${data.id}/apply-use-point`, data);
}

function search(options) {
    return axiosNodeClient.get('/checkin/search', {
        params: {...options, action: 'search'}
    });
}

function checkout(data) {
    return axiosNodeClient.put(`/checkin/do-checkout/${data.id}`, data);
}

function update(data) {
    return axiosNodeClient.put(`/checkin/${data.id}`, data);
}

function del(id) {
    return axiosNodeClient.delete(`/checkin/${id}`);
}

function total() {
    return axiosNodeClient.get('/checkin/total',  {
        params: {
            action: 'getTotal'
        }
    });
}

function today() {
    return axiosNodeClient.get(`/checkin`, {
        params: {
            action: 'getToday'
        }
    });
}
